import apiClient from "../../../apiClient/apiClient";
import { GET_ORGANISER_EVENT_FAILURE, GET_ORGANISER_EVENT_REQUEST, GET_ORGANISER_EVENT_SUCCESS } from "./GetOrganiserEventConstant"

export const fetchOrganiserEvents = (organizerId) => async (dispatch) => {
    dispatch({ type: GET_ORGANISER_EVENT_REQUEST });
    try {
        const token = localStorage.getItem("access") || sessionStorage.getItem("access");
        const config = token ? {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        } : {};

        console.log(`[DEBUG] Fetching organizer events for ID: ${organizerId}`);
        const response = await apiClient.get(`/events/organizer/`, config);
        const firstPageData = response.data;
        
        let allEvents = [...(firstPageData.results || [])];
        let nextPageUrl = firstPageData.next;
        
        // Fetch all pages
        while (nextPageUrl) {
            try {
                console.log(`[DEBUG] Fetching next page: ${nextPageUrl}`);
                const nextPageResponse = await apiClient.get(nextPageUrl, config);
                allEvents = [...allEvents, ...(nextPageResponse.data.results || [])];
                nextPageUrl = nextPageResponse.data.next;
                console.log(`[DEBUG] Total events now: ${allEvents.length}`);
            } catch (error) {
                console.error("Error fetching next page:", error);
                break;
            }
        }
        
        const completeData = {
            ...firstPageData,
            results: allEvents
        };
        
        console.log(`[DEBUG] All organizer events loaded: ${allEvents.length}`);
        dispatch({
            type: GET_ORGANISER_EVENT_SUCCESS,
            payload: completeData
        });
    } catch (error) {
        console.error("Error fetching organizer events:", error);
        dispatch({
            type: GET_ORGANISER_EVENT_FAILURE,
            payload: error.message
        });
    }
};